import React from 'react';

interface CarfaxButtonMessageProps {
  carfaxUrl: string;
}

const CarfaxButtonMessage: React.FC<CarfaxButtonMessageProps> = ({ carfaxUrl }) => {
  const handleClick = () => {
    if (carfaxUrl) {
      window.open(carfaxUrl, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <div className="flex justify-center w-full">
      <button
        onClick={handleClick}
        disabled={!carfaxUrl}
        className="inline-flex items-center justify-center px-4 py-2 bg-white hover:bg-gray-50 d2cbot-bot_border d2cbot-bot_border-gray-300 rounded-md transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
        aria-label="View Carfax Report"
      >
        <img 
          src="https://cdn.carfax.ca/vehicle-history/images/1.0.0/carfax-canada.svg" 
          alt="Carfax Canada" 
          className="h-6"
        />
      </button>
    </div>
  );
};

export default CarfaxButtonMessage;
